import React, {useEffect, useState} from 'react'
import styles from './EventGuestInformation.module.css'
import {useParams} from "react-router";
import LoadingBackdrop from "../../components/common/LoadingBackdrop";

import {
    Checkbox,
    FormControlLabel,
    Grid,
    InputLabel,
    Select,
    SelectChangeEvent
} from "@mui/material";
import {useAutoEvt} from "../../queries/useAutoEvt";
import CheckboxGroup from "../../components/common/inputs/CheckboxGroup";
import Button from "@mui/material/Button";

interface Params {
  eventid: string
}

const EventGuestInformation = () => {
    const { eventid } = useParams<Params>()
    useAutoEvt(eventid)

    const [loading, setLoading] = React.useState(false)
    const [ticketItem, setTicketItem] = useState("-1")


    const handleSelectionChange = async (event: SelectChangeEvent) => {
        setTicketItem(event.target.value as string);
    }

    const getTicketItemOptions = () => {
        // return groupData?.ticketitemlist?.map(item => (
        //     <MenuItem key={item.ticketitemid} value={item.ticketitemid}>
        //         {item.ticketitemname}
        //     </MenuItem>
        // ))
        return []
    }

    return (
        <div className={styles.root}>
            <LoadingBackdrop open={loading} />
            <h1>Guest Information</h1>
            <Grid
                container
                direction="row"
                justifyContent="flex-begin"
                alignItems="center"
                // border={2}
                spacing={2}
                style={{marginBottom: '20px'}}
                xs={12} sm={12} md={12}
            >
                <Grid item xs={4}>
                    <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-begin'}} >
                        <Select
                            onChange={handleSelectionChange}
                            style={{ width: '100%', height:'30px' }}
                            value={ticketItem}>
                            {getTicketItemOptions()}
                        </Select>
                    </InputLabel>
                </Grid>
                <Grid item xs={8}>
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel control={<Checkbox defaultChecked />} label="Include Purchaser Name" />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel control={<Checkbox defaultChecked />} label="Include User Defined Fields" />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel control={<Checkbox defaultChecked />} label="Include System Fields" />
                </Grid>
                <Grid item xs={4}>
                    <Button
                        style={{width: '100%'}}
                        variant="contained"
                        // onClick={() => {downloadInteractionExcel()}}
                        color="primary">
                        EXPORT TO EXCEL
                    </Button>
                </Grid>
                <Grid item xs={8}>
                </Grid>
            </Grid>
        </div>
    )
}

export default EventGuestInformation
